// First publication recorded in Git; duration read from the MP4's mvhd box.
export const videoDemo = {
  path: "/videos/stand-nfc-resenas-google",
  name: "Cómo funciona un stand NFC para reseñas de Google",
  description:
    "Demostración real: un teléfono detecta el chip NFC de un stand Google y abre el formulario de reseña de Pyme Visible.",
  contentPath: "/video/hero-stand-nfc.mp4",
  thumbnailPath: "/video/hero-stand-nfc-poster.webp",
  uploadDate: "2026-09-12T16:46:10-03:00",
  duration: "PT6.8S",
};

export function crearVideoObject() {
  const base = "https://pymevisible.cl";
  return {
    "@type": "VideoObject",
    "@id": `${base}${videoDemo.path}#video`,
    name: videoDemo.name,
    description: videoDemo.description,
    thumbnailUrl: `${base}${videoDemo.thumbnailPath}`,
    contentUrl: `${base}${videoDemo.contentPath}`,
    uploadDate: videoDemo.uploadDate,
    duration: videoDemo.duration,
    inLanguage: "es-CL",
    publisher: { "@id": `${base}/#organization` },
  };
}
